// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal-information_icon__1at_W","message":"modal-information_message__2HkEY"};